import React from 'react';

const ResourceCell = props => {
  return (
    <div className="rbc-timeslot-group">
      <div className="rbc-time-slot resource-cell" style={{overflow: 'hidden'}}>
        {props.employee.EmployeeName}
      </div>
    </div>
  );
};

export default ResourceCell;
